import { PropsWithChildren } from 'react';
import { Card, Modal } from 'react-bootstrap';
import styled from 'styled-components';
import './CardModalStyles.css';
import LinkBtn from './LinkBtn';

const MinCard = styled(Card)`
  min-width: 650px;
  max-height: 550px;
  overflow-y: auto;
`;

const Header = styled(Card.Header)`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const FlexDiv = styled.div`
  flex: 1;
`;

type Props = PropsWithChildren<{
  title?: string;
  subtitle?: string;
  open: boolean;
  onClose: () => void;
  closeClickOutside?: boolean;
}>;

export const CardModal = (props: Props) => {
  const { title, subtitle, children, open, onClose, closeClickOutside } = props;
  return (
    <Modal
      size="lg"
      centered
      show={open}
      onHide={closeClickOutside ? onClose : undefined}
      backdrop="static"
      dialogClassName="my-modal">
      <MinCard>
        <Header>
          <FlexDiv>
            <h2 className="text-info">{title}</h2>
            {subtitle && <h5 className="text-info">{subtitle}</h5>}
          </FlexDiv>
          <div>
            <LinkBtn transparent onClick={onClose}>
              <i className="fa fa-lg fa-times text-muted" />
            </LinkBtn>
          </div>
        </Header>
        <Card.Body>{children}</Card.Body>
      </MinCard>
    </Modal>
  );
};
